var React = require('react');

function PlayTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","d":"M0.236328 2.09302V15.9064C0.236328 16.9597 1.39633 17.5997 2.28966 17.0264L13.143 10.1197C13.9697 9.59969 13.9697 8.39968 13.143 7.86635L2.28966 0.973019C1.39633 0.399685 0.236328 1.03969 0.236328 2.09302Z","fill":"white"}));
}

PlayTriangle.defaultProps = {"width":"14","height":"18","viewBox":"0 0 14 18","fill":"none"};

module.exports = PlayTriangle;

PlayTriangle.default = PlayTriangle;
